import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router'
import useSWR from 'swr'

import { Loading } from '@/components/Loading'
import { PageHeader } from '@/components/ds'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'
import { ProductForm } from '@/forms/ProductForm/ProductForm'
import { Product } from '@/interfaces/catalog/Product'

export default function ProductEditPage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const { t } = useTranslation(undefined, { keyPrefix: 'catalog' })

  const { data: product, isLoading } = useSWR<Product>(id && `/api/v2/products/${id}`, apiFetcher)
  const title = product?.name || t('products.edit.title')

  useSetPageHeader({
    breadcrumbs: [
      { href: '/catalog', children: t('title') },
      { href: '/catalog/products', children: t('products.title') },
      { href: `/catalog/product/${id}`, children: product?.name || id || '' },
      { href: `/catalog/product/${id}/edit`, children: t('products.edit.title') },
    ],
  })

  return (
    <>
      <title>{title}</title>

      {isLoading && <Loading />}

      {product && (
        <div className="mx-auto w-full max-w-[1280px]">
          <PageHeader title={t('products.edit.title')} description={product.name} />
          <ProductForm
            id={product.id}
            defaultValues={{
              name: product.name,
              mainCategoryId: product.mainCategoryId ?? '',
              description: product.description || null,
              secondaryCategoryIds: product.secondaryCategoryIds || [],
              externalId: product.externalId || null,
              isActive: product.isActive ?? true,
              productType: (product.productType as 'physical' | 'virtual' | 'service' | 'package') || 'physical',
              packageItems: [],
            }}
            onCancel={() => navigate(`/catalog/product/${product.id}`)}
            onSuccess={(data) => {
              navigate(`/catalog/product/${data.id}`)
            }}
          />
        </div>
      )}
    </>
  )
}
